import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { post } from "../../../helpers/api_helper";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetReportInvoiceExportMiracle,
  POST_GetReportInvoiceRegisterExport,
  POST_GetReportInvoiceRegisterList,
} from "../../../helpers/url_helper";
import { errorMessage } from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const InvoiceRegister = () => {
  const [showFilter, setShowFilter] = useState(true); //for report screen default true
  const [isLoading, setIsLoading] = useState(false);

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [invoiceRegisterList, setInvoiceRegisterList] = useState([]);

  const typeOptions = [
    { label: "Summary", value: true },
    { label: "Detail", value: false },
  ];

  const paymentStatusOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Paid", value: 1 },
    { label: "Partial Paid", value: 2 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      PaymentStatus: -1,
      IsSummaryReport: true,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      PaymentStatus,
      IsSummaryReport,
    },
  } = formikFilter;

  const handleValidSubmitFilter = (values) => {
    getData();
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      PaymentStatus: -1,
      IsSummaryReport: true,
    });

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData();
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      PaymentStatus: PaymentStatus,
      IsSummaryReport: IsSummaryReport,
    };

    await post(POST_GetReportInvoiceRegisterList, payload)
      .then((response) => {
        setInvoiceRegisterList(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      PaymentStatus: PaymentStatus,
      IsSummaryReport: IsSummaryReport,
      ReportGenerateByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    post(POST_GetReportInvoiceRegisterExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const handleChangeType = (e) => {
    formikFilter.setFieldValue("IsSummaryReport", e?.value ?? "");
    setInvoiceRegisterList([]);
  };

  const exportMiracle = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      PaymentStatus: PaymentStatus,
      ReportGenerateByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    post(POST_GetReportInvoiceExportMiracle, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Invoice Register</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 58 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 58 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportMiracle}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Miracle
                      Format
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Type"
                              name="IsSummaryReport"
                              placeholder={"Select Type"}
                              options={typeOptions}
                              component={CustomSelect}
                              isClearable={false}
                              // menuPosition="fixed"
                              onChange={handleChangeType}
                            />
                          </Col>

                          <Col lg={2}>
                            <label className="mb-1">Invoice Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              // menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="Payment Status"
                              name="PaymentStatus"
                              placeholder={"Select Payment Status"}
                              options={paymentStatusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              // menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <button
                                  className="btn btn-primary btn-sm mb-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div className="table-responsive">
                  <div
                    id="InvoiceRegister-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                    style={{ height: "510px", overflowY: "auto" }}
                  >
                    <table
                      id="InvoiceRegister-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="fixedheader">
                        <tr>
                          <th
                            width="2%"
                            style={{ minWidth: "50px", textAlign: "center" }}
                          >
                            #
                          </th>
                          <th width="6%" style={{ minWidth: "120px" }}>
                            Invoice No
                          </th>
                          <th width="5%" style={{ minWidth: "100px" }}>
                            Invoice Date
                          </th>
                          <th width="7%" style={{ minWidth: "300px" }}>
                            Customer Name
                          </th>
                          <th width="6%" style={{ minWidth: "120px" }}>
                            GST No
                          </th>
                          <th width="7%" style={{ minWidth: "150px" }}>
                            Contact Person
                          </th>
                          {IsSummaryReport == false && (
                            <>
                              <th width="7%" style={{ minWidth: "280px" }}>
                                Inward No
                              </th>
                              <th width="7%" style={{ minWidth: "280px" }}>
                                TC No
                              </th>
                              <th
                                width="6%"
                                style={{
                                  minWidth: "120px",
                                  textAlign: "right",
                                }}
                              >
                                Gross Amount
                              </th>
                              <th
                                width="6%"
                                style={{
                                  minWidth: "120px",
                                  textAlign: "right",
                                }}
                              >
                                Other Expense
                              </th>
                              <th
                                width="6%"
                                style={{
                                  minWidth: "120px",
                                  textAlign: "right",
                                }}
                              >
                                Discount Amount
                              </th>
                              <th
                                width="6%"
                                style={{
                                  minWidth: "110px",
                                  textAlign: "right",
                                }}
                              >
                                GST Amount
                              </th>
                              <th
                                width="6%"
                                style={{
                                  minWidth: "110px",
                                  textAlign: "right",
                                }}
                              >
                                Rounding Off
                              </th>
                            </>
                          )}
                          <th
                            width="6%"
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            Invoice Amount
                          </th>
                          <th
                            width="6%"
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            Received Amount
                          </th>
                          <th
                            width="6%"
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            Pending Amount
                          </th>
                          <th width="5%" style={{ textAlign: "left" }}>
                            Payment Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceRegisterList?.length > 0 ? (
                          <>
                            {invoiceRegisterList?.map((item, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  {item?.RowNo}
                                </td>
                                <td>{item?.InvoiceNo}</td>
                                <td>{item?.InvoiceDate}</td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item?.CustomerName}
                                </td>
                                <td>{item?.GSTNo}</td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item?.ContactPerson}
                                </td>
                                {IsSummaryReport == false && (
                                  <>
                                    <td
                                      style={{
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {item?.InwardNo}
                                    </td>
                                    <td
                                      style={{
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {item?.TCNo}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item?.GrossAmount}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item?.OtherExpense}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item?.DiscountAmount}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item?.GSTAmount}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item?.RoundingOff}
                                    </td>
                                  </>
                                )}
                                <td style={{ textAlign: "right" }}>
                                  {item?.InvoiceAmount}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item?.ReceivedAmount}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item?.PendingAmount}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item?.PaymentStatus}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={17} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default InvoiceRegister;
